import {useAuthStore} from '@/store/auth'

export default defineNuxtRouteMiddleware(() => {
    if (process.server) return

    const authStore = useAuthStore()
    const {isLoggedIn} = storeToRefs(authStore)
    if (isLoggedIn.value) return navigateTo(useNuxtApp().$routerUrl('/'))
})